import MediaUtil from "./MediaUtil.js";

const GuiUtil = {
	/** Create file name slug */
	updateLink(linkId, nameId, extension) {
		const nameElement = $("#" + nameId);
		const linkElement = $("#" + linkId);
		linkElement.val(MediaUtil.generateFileName(nameElement.val()), extension);
	}
};

window.GuiUtil = GuiUtil;	// Expose as global

export default GuiUtil;